import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
    .free-course-area {
        padding: 10px 0;

        .course-text {
            padding-left: 50px;
            margin-top   : 20px;

            h4 {
                color        : ${colors.black1};
                line-height  : 35px;
                font-weight  : 600;
                margin-bottom: 25px;

                @media(max-width: 575px) {
                    margin-bottom: 15px;
                    font-size: 20px;
                }
            }

            p {
                font-size    : 13px;
                color        : #666666;
                line-height  : 28px;
                margin-bottom: 15px;

                @media(max-width: 575px) {
                    font-size: 12px;
                    margin-bottom: 20px;
                }
                @media (max-width: 991px) {
                    font-size: 12px;
                    -webkit-letter-spacing: 0;
                    -moz-letter-spacing: 0;
                    -ms-letter-spacing: 0;
                    letter-spacing: 0;
                }
            }

            @media(max-width: 767px) {
                margin-top   : 0;
            }
        }

        .how_we_work_image_new{
            max-width: 100%;
            height: auto;
            object-fit: contain;
        
            @media(max-width: 575px) {
                padding: 30px 0 40px;
            }
            @media(max-width: 767px) {
                padding: 30px 0 40px;
            }
            @media (max-width: 991px) {
                padding: 30px 0 40px;
            }
        }
    }
`;